import React from 'react';
import { Pagination as BsPagination } from 'react-bootstrap';

function Pagination({ currentPage, totalPages, maxVisiblePages = 5, onPageChange }) {
  const handleClick = (page) => {
    if (page < 1 || page > totalPages || page === currentPage) return;
    onPageChange(page);
  };

  const getMiddlePageNumbers = () => {
    const pages = [];

    let start = Math.max(2, currentPage - Math.floor(maxVisiblePages / 2));
    let end = start + maxVisiblePages - 1;

    if (end >= totalPages) {
      end = totalPages - 1;
      start = Math.max(2, end - maxVisiblePages + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  if (totalPages <= 1) return null;

  return (
    <BsPagination>
      <BsPagination.Prev
        onClick={ () => handleClick(currentPage - 1) }
        disabled={ currentPage === 1 }
      />

      <BsPagination.Item
        active={ currentPage === 1 }
        onClick={ () => handleClick(1) }
      >
        1
      </BsPagination.Item>

      {getMiddlePageNumbers()[0] > 2 && <BsPagination.Ellipsis disabled />}

      {getMiddlePageNumbers().map((page) => (
        <BsPagination.Item
          key={ page }
          active={ currentPage === page }
          onClick={ () => handleClick(page) }
        >
          {page}
        </BsPagination.Item>
      ))}

      {getMiddlePageNumbers().slice(-1)[0] < totalPages - 1 && (
        <BsPagination.Ellipsis disabled />
      )}

      {totalPages > 1 && (
        <BsPagination.Item
          active={ currentPage === totalPages }
          onClick={ () => handleClick(totalPages) }
        >
          {totalPages}
        </BsPagination.Item>
      )}

      <BsPagination.Next
        onClick={ () => handleClick(currentPage + 1) }
        disabled={ currentPage === totalPages }
      />
    </BsPagination>
  );
}

export default Pagination;
